import type { FaqSection } from "./types";

const includedInPlatformFee = [
  {
    title: "Sales Core",
    description: "solar design*, proposals, financing, e-signature in one platform",
  },
  {
    title: "Install Tracker",
    description: "project management and milestone tracking",
  },
  {
    title: "Customer Portals",
    description: "branded homeowner portals for status updates and communication",
  },
  {
    title: "Onboarding & Training",
    description: "guided setup and best practices",
  },
  {
    title: "Dedicated Account Support",
    description: "a real person who knows your business",
  },
  {
    title: "Reporting & Analytics",
    description: "performance, operations, and sales insights",
  },
];

const pricingSection: FaqSection = {
  id: "pricing-contract",
  title: "Pricing & Contract",
  faqs: [
    {
      question: "How much does Enerflo cost?",
      answer: (
        <p>
          Enerflo pricing is a flat-rate monthly subscription based on your average monthly volume. Unlike some
          platforms, we do not charge per seat, design, proposal, contract, or job—helping you manage cash flow with
          predictable, all-inclusive subscription fees. A one-time implementation fee covers configuring your Enerflo
          instance to match your specific workflows, tools, and processes. For a custom quote tailored to your company’s
          goals, size, and volume, contact our team.
        </p>
      ),
    },
    {
      question: "Is there a minimum contract length?",
      answer: (
        <p>
          Yes. Enerflo requires a 12-month minimum contract for new partners. Flexible pricing options are available for
          both single-organization and multi-organization setups, so you can choose the configuration that works best
          for your business. Request pricing details.
        </p>
      ),
    },
    {
      question: "Are there additional fees for integrations or custom work?",
      answer: (
        <p>
          Core integrations are included with every Enerflo subscription. Additional one-time costs may apply for custom
          API development, advanced features, or complex CRM and software configurations. We also offer optional
          integration monitoring services for an additional monthly fee to ensure smooth, ongoing performance.
        </p>
      ),
    },
    {
      question: "Are there discounts for high-volume or enterprise customers?",
      answer: (
        <p>
          Yes. Enerflo offers tiered pricing and volume discounts for companies with high transaction volumes, multiple
          sales organizations, or integrated sales and install operations. Talk to sales to learn more about enterprise
          pricing.
        </p>
      ),
    },
    {
      question: "What’s included in the monthly Enerflo platform fee?",
      answer: (
        <>
          <p>Your monthly subscription includes:</p>
          <br />
          <ul className="list-disc space-y-1 ml-4">
            {includedInPlatformFee.map(item => (
              <li key={item.title}>
                <strong>{item.title}</strong> –{item.description}
              </li>
            ))}
          </ul>
          <br />
          <p>
            Add-on features, advanced integrations, and premium services are available for an additional one-time or
            recurring fee.
          </p>
          <br />
          <p className="text-sm">
            * Enerflo Sales Core supports integrated solar design tools, such as Aerialytic, Aurora, OpenSolar, etc.
          </p>
        </>
      ),
    },
  ],
};

export default pricingSection;
